import React, { useContext, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import FlexComponent from '../../FlexComponent'
import { Avatar } from 'primereact/avatar'
import { Button } from 'primereact/button'
import CheckList from './CheckList';
import Activity from './Activity';
import { useNavigate } from 'react-router-dom';
import Description from './Description';
import Label from './Label';
import { Divider } from 'primereact/divider';
import CheckListContainer from './CheckListContainer';
import CustomField from './CustomField';
import Watcher from './Watcher';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import '../apps.css';
import Members from './Members';
import { useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import axios from '../../../utils/axios';
import { appSubmission, archiveSubmission, autoDocFollowupToggle, deleteSubmission, downloadXmlFile, inactiveSubmission, updateDueDate, upserCustomFieldValue, createAppDoc, updateAppDoc, updateCheckList, createCheckList } from '../../../utils/urls';
import useAppDocs from '../useAppDocs';
import AppModal from '../../../shared/AppModal';
import { Calendar } from 'primereact/calendar';
import ShoppingFor from '../../profileView/ShoppingFor';
import MessageTracker from './MessageTracker';
import Queue from './Queue';
import { OverlayPanel } from 'primereact/overlaypanel';
import ChecklistModal from './ChecklistModal';
import DocsModal from '../DocsModal';
import PreviewTitle from '../PreviewTitle';
import PreviewFile from './PreviewFile';
import { WorkingOnBanner } from '../workingOn/WorkingOn';
import { AppModalHeaderSlot } from '../../../shared/AppModal';
import CoBorrowers from '../CoBorrowers';

function changeIncomeColor(applicantIncome) {
    if (!applicantIncome) return '';
    let str = applicantIncome.toLowerCase().replace(/[$,]/g, '').trim();
    let income = 0;

    if (str.endsWith('k')) {
        income = parseFloat(str) * 1000;
    } else {
        income = parseFloat(str);
    }
    if (isNaN(income)) return '';
    if (income >= 80000) {
        return '#00C896';
    } else if (income >= 65000) {
        return '#FFB400';
    } else {
        return '#FF4E4E';
    }
}

function changeCreditColor(applicantCredit) {
    const credit = parseInt(applicantCredit);
    if (isNaN(credit)) return '';
    if (credit >= 620) {
        return '#00C896';
    } else if (credit < 620 && credit >= 500) {
        return '#FFB400';
    } else {
        return '#FF4E4E'
    }
}

function changeAvailableColor(cashAvailable) {
    if (!cashAvailable) return '';

    let str = cashAvailable.toLowerCase().replace(/[$,]/g, '').trim();
    let amount = 0;

    if (str.endsWith('k')) {
        amount = parseFloat(str) * 1000;
    } else {
        amount = parseFloat(str);
    }

    if (isNaN(amount)) return '';

    if (amount >= 45000) {
        return '#00C896';
    } else if (amount >= 20000) {
        return '#FFB400';
    } else {
        return '#FF4E4E';
    }
}

function formatDateTime(inputDateTime) {
    if (!inputDateTime) return ''
    const [datePart, timePart, period] = inputDateTime?.split(' ');
    const [year, month, day] = datePart?.split('-');
    let [hour, minute] = timePart?.split(':');
    if (period === 'PM' && hour !== '12') {
        hour = parseInt(hour) + 12;
    } else if (period === 'AM' && hour === '12') {
        hour = '00';
    }
    const date = new Date(year, month - 1, day, hour, minute);
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const formattedDate = `${monthNames[date.getMonth()]} ${parseInt(day)}, ${year}`;
    let formattedHour = date.getHours();
    let formattedMinute = date.getMinutes().toString().padStart(2, '0');
    let ampm = formattedHour >= 12 ? 'pm' : 'am';
    formattedHour = formattedHour % 12 || 12;
    formattedHour = formattedHour.toString().padStart(2, '0');

    const formattedTime = `${formattedHour}:${formattedMinute}${ampm}`;

    return `${formattedDate} | ${formattedTime}`;
}

function convertDate(utcDateString) {
    if (!utcDateString) return ""
    const utcDate = new Date(utcDateString);

    const dateOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    };

    const timeOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };

    const formattedDate = utcDate.toLocaleDateString('en-US', dateOptions);
    const formattedTime = utcDate.toLocaleTimeString('en-US', timeOptions);

    const formattedLocalDateTime = `${formattedDate} | ${formattedTime.toLowerCase()}`;

    return formattedLocalDateTime
}

function AppPopup({ id, isFromTable = false, stageIds, setIsMounted, isMounted, setApplicantData, setTotal, isFromSearch = false, allPipelinesData, applicantData, pipelineStages, handleStageUpdate, loanDetailsCustomFields, realEstateTransactionsCustomFields, allCustomFields, pipelineId = 1, usersList, userId, setBoardSections, getAllCustomFields, handleClose, isFromQueuePage=false, fetchQueue, toast }) {
    const navigate = useNavigate()
    const headerSlot = useContext(AppModalHeaderSlot)
    const [isEditDueDate, setIsEditDueDate] = useState(false)
    const [dueDateTime, setDueDateTime] = useState(applicantData?.due_date ? new Date(applicantData.due_date) : null)
    const [savedDateTime, setSavedDateTime] = useState(applicantData?.due_date)
    const isSuperuser = useSelector((state) => state.user.isSuperuser)
    const designation = useSelector((state) => state.user.designation)
    const [deleteOption, setDeleteOption] = useState([])
    const [stageName, setStageName] = useState(id)
    const [selectedStageId, setSelectedStageId] = useState(id)
    
    const stagesInfo = Array.isArray(applicantData?.stages_info) ? applicantData.stages_info : []
    const [stageNames, setStageNames] = useState(
        stagesInfo.reduce((acc, stage) => ({
            ...acc,
            [stage.stage_pipeline_id]: stage.stage_name
        }), {})
    )
    const [visible, setVisible] = useState(false);
    const dotsOp = useRef(null);

    const [emailPopupVisible, setEmailPopupVisible] = useState(false)
    const [wantEmail, setWantEmail] = useState(null)
    const [closingDateVisible, setClosingDateVisible] = useState(false)
    const [emails, setEmails] = useState([])
    const [emailInput, setEmailInput] = useState('')
    const [closingDate, setClosingDate] = useState([])
    const [selectedPipelineId, setSelectedPipelineId] = useState("")
    const [selectedStageName, setSelectedStageName] = useState("")
    const [customFieldUpdateAppId, setCustomFieldUpdateAppId] = useState(null)

    let sampleHomeType = ["1", "3+"]

    const [autoDocToogle, setAutoDocToggle] = useState(applicantData?.is_doc_followup)
    const [checklistModalVisible, setChecklistModalVisible] = useState(false)

    // DocsModal state
    const [localHeadings, setLocalHeadings] = useState(
        (applicantData?.checklist_heading || []).map(h => ({
            ...h,
            items: (h.items || []).map(it => ({
                ...it,
                id: it.id || it.checklist_id,
                is_completed: it.is_completed !== undefined ? it.is_completed : it.completed,
            }))
        }))
    );
    const [docsVisible, setDocsVisible]           = useState(false);
    const [renamingFileId, setRenamingFileId]     = useState(null);
    const [renameValue, setRenameValue]           = useState('');
    const [pendingDocs, setPendingDocs]           = useState([]);
    const [modalUploading, setModalUploading]     = useState(false);
    const [docViewMode, setDocViewMode]           = useState('list');
    const [previewFile, setPreviewFile]           = useState(null);
    const [previewVisible, setPreviewVisible]     = useState(false);
    const [pendingUploadFiles, setPendingUploadFiles]   = useState([]);
    const [uploadPickerVisible, setUploadPickerVisible] = useState(false);
    const { appDocs, setAppDocs, reloadAppDocs, loadMoreAppDocs, appDocsHasMore, appDocsLoading, appDocsTotal, appDocsOrdering, setAppDocsOrdering } =
        useAppDocs(applicantData?.form_id, docsVisible);
    const [checklistRefreshToken, setChecklistRefreshToken] = useState(0);

    const fmtFileSize = (bytes) => {
        if (!bytes) return '—';
        if (bytes >= 1e6) return `${(bytes / 1e6).toFixed(1).replace(/\.0$/, '')} MB`;
        if (bytes >= 1e3) return `${Math.round(bytes / 1e3)} KB`;
        return `${bytes} B`;
    };

    const updateLocalItem = (id, patch) =>
        setLocalHeadings(prev => prev.map(h => ({
            ...h,
            items: (h.items || []).map(it => it.id === id ? { ...it, ...patch } : it)
        })));

    const allItems = localHeadings.flatMap(h => h.items || []);
    const allFiles = allItems.flatMap(it => (it.file_url || []).map(f => ({
        ...f, itemLabel: it.item, itemId: it.id, itemDone: it.is_completed
    })));
    const linkedAppDocIds = new Set(allFiles.map(f => f.app_doc_id).filter(Boolean));
    const allFilesForModal = [
        ...allFiles,
        ...pendingDocs.map(d => ({
            id: null, app_doc_id: d.app_doc_id,
            file_url: d.file_url, file_name: d.file_name, file_size: d.file_size,
            uploaded_by: d.uploaded_by, uploaded_at: d.uploaded_at, uploaded_at_iso: d.uploaded_at_iso,
            itemLabel: null, itemId: null, itemDone: false, isPending: true,
        })),
        ...appDocs
            .filter(d => !linkedAppDocIds.has(d.app_doc_id))
            .map(d => ({
                id: null, app_doc_id: d.app_doc_id,
                file_url: d.file_url, file_name: d.file_name, file_size: d.file_size,
                uploaded_by: d.uploaded_by, uploaded_at: d.uploaded_at, uploaded_at_iso: d.uploaded_at_iso,
                itemLabel: null, itemId: null, itemDone: false, isIndependent: true,
            })),
    ];

    const handleToggle = (item) => {
        const newVal = !item.is_completed;
        updateLocalItem(item.id, { is_completed: newVal });
        const fd = new FormData();
        fd.append('item', item.item || '');
        fd.append('due_date', item.due_date || '');
        fd.append('is_completed', newVal);
        fd.append('mention', JSON.stringify([]));
        fd.append('assigned_user', JSON.stringify([]));
        axios.post(`${updateCheckList}${item.id}/${userId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
            .catch(() => {
                updateLocalItem(item.id, { is_completed: item.is_completed });
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to update item', life: 3000 });
            });
    };


    const handleRenameFile = async (file, newName) => {
        setRenamingFileId(null);
        if (!newName.trim() || newName.trim() === file.file_name) return;
        const trimmed = newName.trim();
        setLocalHeadings(prev => prev.map(h => ({
            ...h,
            items: (h.items || []).map(it => ({
                ...it,
                file_url: (it.file_url || []).map(f => f.id === file.id ? { ...f, file_name: trimmed } : f)
            }))
        })));
        setAppDocs(prev => prev.map(d => d.app_doc_id === file.app_doc_id ? { ...d, file_name: trimmed } : d));
        try {
            await axios.patch(`${updateAppDoc}${file.app_doc_id}/`, { file_name: trimmed });
            setChecklistRefreshToken(prev => prev + 1);
            toast.current?.show({ severity: 'success', summary: 'Renamed', life: 2000 });
            return true;
        } catch {
            setLocalHeadings(prev => prev.map(h => ({
                ...h,
                items: (h.items || []).map(it => ({
                    ...it,
                    file_url: (it.file_url || []).map(f => f.id === file.id ? { ...f, file_name: file.file_name } : f)
                }))
            })));
            setAppDocs(prev => prev.map(d => d.app_doc_id === file.app_doc_id ? { ...d, file_name: file.file_name } : d));
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to rename', life: 3000 });
            return false;
        }
    };

    const handleRenamePreviewFile = async (name) => {
        const previous = previewFile.file_name;
        setPreviewFile(p => p && { ...p, file_name: name });
        if (await handleRenameFile(previewFile, name) === false) {
            setPreviewFile(p => p && { ...p, file_name: previous });
        }
    };

    const handleRefileDoc = async (file, newItemId) => {
        if (newItemId === file.itemId) return;
        const oldItem = allItems.find(it => it.id === file.itemId);
        const newItem = allItems.find(it => it.id === newItemId);
        if (!oldItem || !newItem) return;
        setLocalHeadings(prev => prev.map(h => ({
            ...h,
            items: (h.items || []).map(it => {
                if (it.id === file.itemId) return { ...it, file_url: (it.file_url || []).filter(f => f.id !== file.id) };
                if (it.id === newItemId)   return { ...it, file_url: [...(it.file_url || []), file] };
                return it;
            })
        })));
        try {
            const fdOld = new FormData();
            fdOld.append('item', oldItem.item || '');
            fdOld.append('due_date', oldItem.due_date || '');
            fdOld.append('is_completed', oldItem.is_completed ? 'true' : 'false');
            fdOld.append('mention', JSON.stringify([]));
            fdOld.append('assigned_user', JSON.stringify([]));
            fdOld.append('removed_file_ids', JSON.stringify([file.id]));
            fdOld.append('renamed_files', JSON.stringify([]));
            await axios.post(`${updateCheckList}${oldItem.id}/${userId}`, fdOld, { headers: { 'Content-Type': 'multipart/form-data' } });

            const fdNew = new FormData();
            fdNew.append('item', newItem.item || '');
            fdNew.append('due_date', newItem.due_date || '');
            fdNew.append('is_completed', newItem.is_completed ? 'true' : 'false');
            fdNew.append('mention', JSON.stringify([]));
            fdNew.append('assigned_user', JSON.stringify([]));
            fdNew.append('app_doc_ids', JSON.stringify([file.app_doc_id]));
            fdNew.append('renamed_files', JSON.stringify([]));
            const res = await axios.post(`${updateCheckList}${newItem.id}/${userId}`, fdNew, { headers: { 'Content-Type': 'multipart/form-data' } });
            if (res.data?.file_url) updateLocalItem(newItem.id, { file_url: res.data.file_url });
            setChecklistRefreshToken(prev => prev + 1);
            toast.current?.show({ severity: 'success', summary: 'Document moved', life: 2000 });
        } catch {
            setLocalHeadings(prev => prev.map(h => ({
                ...h,
                items: (h.items || []).map(it => {
                    if (it.id === file.itemId) return { ...it, file_url: [...(it.file_url || []), file] };
                    if (it.id === newItemId)   return { ...it, file_url: (it.file_url || []).filter(f => f.id !== file.id) };
                    return it;
                })
            })));
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to move document', life: 3000 });
        }
    };

    const handleAssignPendingDoc = async (doc, itemId) => {
        const item = allItems.find(it => it.id === itemId);
        if (!item) return;
        setPendingDocs(prev => prev.filter(d => d.app_doc_id !== doc.app_doc_id));
        try {
            const fd = new FormData();
            fd.append('item', item.item || '');
            fd.append('due_date', item.due_date || '');
            fd.append('is_completed', item.is_completed ? 'true' : 'false');
            fd.append('mention', JSON.stringify([]));
            fd.append('assigned_user', JSON.stringify([]));
            fd.append('app_doc_ids', JSON.stringify([doc.app_doc_id]));
            fd.append('renamed_files', JSON.stringify([]));
            const res = await axios.post(`${updateCheckList}${item.id}/${userId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            if (res.data?.file_url) updateLocalItem(item.id, { file_url: res.data.file_url });
            setChecklistRefreshToken(prev => prev + 1);
            toast.current?.show({ severity: 'success', summary: 'Document filed', life: 2000 });
        } catch {
            setPendingDocs(prev => [...prev, doc]);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to file document', life: 3000 });
        }
    };

    const handleRenameToSuggestion = async (doc, newName) => {
        const item = allItems.find(it => it.id === doc.itemId);
        if (!item) return;
        const prevName = item.item;
        updateLocalItem(item.id, { item: newName });
        try {
            const fd = new FormData();
            fd.append('item', newName);
            fd.append('due_date', item.due_date || '');
            fd.append('is_completed', item.is_completed ? 'true' : 'false');
            fd.append('mention', JSON.stringify([]));
            fd.append('assigned_user', JSON.stringify([]));
            fd.append('renamed_files', JSON.stringify([]));
            await axios.post(`${updateCheckList}${item.id}/${userId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            setChecklistRefreshToken(prev => prev + 1);
            toast.current?.show({ severity: 'success', summary: 'Checklist item updated', life: 2000 });
        } catch {
            updateLocalItem(item.id, { item: prevName });
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to update item', life: 3000 });
        }
    };

    const handleDeleteDoc = async (f) => {
        if (!f.app_doc_id) return;
        try {
            if (!f.isPending && !f.isIndependent && f.itemId) {
                const fd = new FormData();
                fd.append('item', f.itemLabel || '');
                fd.append('due_date', '');
                fd.append('is_completed', 'false');
                fd.append('mention', JSON.stringify([]));
                fd.append('assigned_user', JSON.stringify([]));
                fd.append('removed_file_ids', JSON.stringify([f.id]));
                fd.append('renamed_files', JSON.stringify([]));
                await axios.post(`${updateCheckList}${f.itemId}/${userId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                setLocalHeadings(prev => prev.map(h => ({
                    ...h,
                    items: (h.items || []).map(it => ({
                        ...it,
                        file_url: (it.file_url || []).filter(file => file.app_doc_id !== f.app_doc_id),
                    })),
                })));
                setChecklistRefreshToken(prev => prev + 1);
            } else {
                await axios.delete(`${updateAppDoc}${f.app_doc_id}/`);
                if (f.isPending) {
                    setPendingDocs(prev => prev.filter(d => d.app_doc_id !== f.app_doc_id));
                } else {
                    setAppDocs(prev => prev.filter(d => d.app_doc_id !== f.app_doc_id));
                }
            }
            toast.current?.show({ severity: 'success', summary: 'Deleted', life: 2000 });
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete document', life: 3000 });
        }
    };

    const handleAssignIndependentToHeading = async (doc, headingId) => {
        setAppDocs(prev => prev.filter(d => d.app_doc_id !== doc.app_doc_id));
        try {
            const fdCreate = new FormData();
            fdCreate.append('item', '');
            fdCreate.append('due_date', '');
            fdCreate.append('heading_id', headingId);
            fdCreate.append('mention', JSON.stringify([]));
            fdCreate.append('assigned_user', JSON.stringify([]));
            const createRes = await axios.post(`${createCheckList}${applicantData?.form_id}/${userId}`, fdCreate, { headers: { 'Content-Type': 'multipart/form-data' } });
            const newItemId = createRes.data.checklist_id;

            const fdAssign = new FormData();
            fdAssign.append('item', '');
            fdAssign.append('due_date', '');
            fdAssign.append('is_completed', 'false');
            fdAssign.append('mention', JSON.stringify([]));
            fdAssign.append('assigned_user', JSON.stringify([]));
            fdAssign.append('app_doc_ids', JSON.stringify([doc.app_doc_id]));
            fdAssign.append('renamed_files', JSON.stringify([]));
            const assignRes = await axios.post(`${updateCheckList}${newItemId}/${userId}`, fdAssign, { headers: { 'Content-Type': 'multipart/form-data' } });

            const newItem = {
                id: newItemId, item: '', is_completed: false, due_date: '',
                file_url: assignRes.data?.file_url || [doc],
                mention: [], assigned_user: [],
            };
            setLocalHeadings(prev => prev.map(h =>
                h.id === headingId ? { ...h, items: [...(h.items || []), newItem] } : h
            ));
            setChecklistRefreshToken(prev => prev + 1);
            toast.current?.show({ severity: 'success', summary: 'Document filed', life: 2000 });
        } catch {
            setAppDocs(prev => [...prev, doc]);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to file document', life: 3000 });
        }
    };

    const doModalUpload = async (files, headingId) => {
        setModalUploading(true);
        try {
            const created = await Promise.all(
                files.map(f => {
                    const fd = new FormData();
                    fd.append('app_id', applicantData?.form_id);
                    fd.append('file', f);
                    fd.append('file_name', f.name);
                    return axios.post(createAppDoc, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
                        .then(r => r.data);
                })
            );
            const heading = headingId
                ? localHeadings.find(h => h.id === headingId)
                : localHeadings[0];
            if (heading) {
                const fdCreate = new FormData();
                fdCreate.append('item', '');
                fdCreate.append('due_date', '');
                fdCreate.append('heading_id', heading.id);
                fdCreate.append('mention', JSON.stringify([]));
                fdCreate.append('assigned_user', JSON.stringify([]));
                const createRes = await axios.post(
                    `${createCheckList}${applicantData?.form_id}/${userId}`,
                    fdCreate,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                const newItemId = createRes.data.checklist_id;
                const fdAssign = new FormData();
                fdAssign.append('item', '');
                fdAssign.append('due_date', '');
                fdAssign.append('is_completed', 'false');
                fdAssign.append('mention', JSON.stringify([]));
                fdAssign.append('assigned_user', JSON.stringify([]));
                fdAssign.append('app_doc_ids', JSON.stringify(created.map(d => d.app_doc_id)));
                fdAssign.append('renamed_files', JSON.stringify([]));
                const assignRes = await axios.post(
                    `${updateCheckList}${newItemId}/${userId}`,
                    fdAssign,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                const newItem = {
                    id: newItemId,
                    item: '',
                    is_completed: false,
                    due_date: '',
                    file_url: assignRes.data?.file_url || created,
                    mention: [],
                    assigned_user: [],
                };
                setLocalHeadings(prev => prev.map(h =>
                    h.id === heading.id ? { ...h, items: [...(h.items || []), newItem] } : h
                ));
            } else {
                setPendingDocs(prev => [...prev, ...created]);
            }
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Upload failed', detail: 'Could not upload file(s)', life: 3000 });
        } finally {
            setModalUploading(false);
        }
    };

    const doIndependentUpload = async (files) => {
        setModalUploading(true);
        try {
            await Promise.all(
                files.map(f => {
                    const fd = new FormData();
                    fd.append('app_id', applicantData?.form_id);
                    fd.append('file', f);
                    fd.append('file_name', f.name);
                    return axios.post(createAppDoc, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                })
            );
            await reloadAppDocs();
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Upload failed', detail: 'Could not upload file(s)', life: 3000 });
        } finally {
            setModalUploading(false);
        }
    };

    const handleModalUpload = (files) => {
        if (localHeadings.length > 1) {
            setPendingUploadFiles(files);
            setUploadPickerVisible(true);
        } else {
            doModalUpload(files, localHeadings[0]?.id);
        }
    };

    const handleUploadHeadingPick = (headingId) => {
        const files = pendingUploadFiles;
        setPendingUploadFiles([]);
        setUploadPickerVisible(false);
        doModalUpload(files, headingId);
    };

    const cancelUploadPicker = () => {
        setPendingUploadFiles([]);
        setUploadPickerVisible(false);
    };

    // console.log("allPipelinesData", allPipelinesData);

    // Initialize date and time fields when savedDateTime changes
    useEffect(() => {
        if (savedDateTime) {
            setDueDateTime(new Date(savedDateTime))
        } else {
            setDueDateTime(null)
        }
    }, [savedDateTime])

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    const handleUpdateDueDate = (isClear = false) => {
        if (isClear) {
            setSavedDateTime(null)
            setDueDateTime(null)
            setIsEditDueDate(false)
            const data = {
                form_id: applicantData.form_id,
                pipeline_id: pipelineId,
                due_date: null
            }
            axios.post(updateDueDate, data, {
                headers: { 'Content-Type': 'application/json' },
            })
                .then((response) => {
                    if (response.status === 200) {
                        if (!isFromTable) {
                            setBoardSections(prevSections => {
                                const updatedSections = { ...prevSections };
                                for (const sectionId in updatedSections) {
                                    updatedSections[sectionId] = updatedSections[sectionId].map(item => {
                                        if (item.form_id === applicantData.form_id) {
                                            return { ...item, due_date: null };
                                        }
                                        return item;
                                    });
                                }
                                return updatedSections;
                            });
                        }
                    } else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        handleClose()
                    }
                })
                .catch((error) => {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleClose()
                })
            return
        }

        // Validate and save date/time
        if (!dueDateTime || isNaN(dueDateTime)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Invalid date or time', life: 3000 })
            return
        }

        setSavedDateTime(dueDateTime)
        setIsEditDueDate(false)
        const data = {
            form_id: applicantData.form_id,
            pipeline_id: pipelineId,
            due_date: dueDateTime
        }
        axios.post(updateDueDate, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    if (!isFromTable) {
                        setBoardSections(prevSections => {
                            const updatedSections = { ...prevSections };
                            for (const sectionId in updatedSections) {
                                updatedSections[sectionId] = updatedSections[sectionId].map(item => {
                                    if (item.form_id === applicantData.form_id) {
                                        return { ...item, due_date: dueDateTime };
                                    }
                                    return item;
                                });
                            }
                            return updatedSections;
                        });
                    }
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleClose()
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleClose()
            })
    }

    const DownloadLoanXMLButton = async () => {
        try {
            const response = await axios.get(`${downloadXmlFile}${applicantData?.form_id}`, {
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'application/xml' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            const name = applicantData?.full_name?.replace(/ /g, '_') || 'loan_application';
            link.download = `${name}_LOAN_APPLICATION_XML.xml`;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading XML:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to download XML file',
                life: 3000,
            });
        }
    };

    const toggleAutoDoc = async () => {
        try {
            const data = {
                is_doc_followup: !applicantData?.is_doc_followup,
            }
            setAutoDocToggle(!autoDocToogle)
            const response = await axios.post(`${autoDocFollowupToggle}${applicantData?.form_id}/`, data);
            if (response.status === 200) {
                toast.current.show({ severity: 'success', summary: '', detail: 'Success', life: 3000 });
            } else {
                console.error('Failed to update order');
            }
        } catch (error) {
            console.error('Error updating order:', error);
        }
    }

    const handleArchiveCard = (event) => {
        confirmPopup({
            message: 'Are you sure you want to Archive this card?',
            target: event.currentTarget,
            group: 'headless',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                if (!isFromTable) {
                    setBoardSections(prevSections => {
                        const updatedSections = { ...prevSections };
                        for (const sectionId in updatedSections) {
                            updatedSections[sectionId] = updatedSections[sectionId].filter((item) => item.form_id !== applicantData.form_id)
                        }
                        return updatedSections;
                    });
                }
                const Url = `${archiveSubmission}${applicantData?.form_id}`
                axios.post(Url, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            toast.current.show({ severity: 'success', summary: 'SuccessFully Archived', detail: '', life: 3000 });
                        }
                    })
                    .catch((error) => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    })
            },
            reject: () => {
                console.log("closed")
            }
        });
    };

    const handleInactiveCard = (event) => {
        confirmPopup({
            message: 'Are you sure you want to move this card to Inactive Apps?',
            target: event.currentTarget,
            group: 'headless',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                if (!isFromTable) {
                    setBoardSections(prevSections => {
                        const updatedSections = { ...prevSections };
                        for (const sectionId in updatedSections) {
                            updatedSections[sectionId] = updatedSections[sectionId].filter((item) => item.form_id !== applicantData.form_id)
                        }
                        return updatedSections;
                    });
                }
                const payloadData = {
                    userId: userId
                }
                const Url = `${inactiveSubmission}${applicantData?.form_id}`
                axios.post(Url, payloadData, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            toast.current.show({ severity: 'success', summary: 'SuccessFully Moved to Inactive Apps', detail: '', life: 3000 });
                        }
                    })
                    .catch((error) => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    })
            },
            reject: () => {
                console.log("closed")
            }
        });
    };

    const handleDeleteCard = (event) => {
        // Reset to initial option if needed (optional)
        setDeleteOption([]);
        setVisible(true); // Open the dialog
    };

    const acceptDelete = () => {
        if (!isFromTable) {
            setBoardSections(prevSections => {
                const updatedSections = { ...prevSections };
                for (const sectionId in updatedSections) {
                    updatedSections[sectionId] = updatedSections[sectionId].filter((item) => item.form_id !== applicantData.form_id)
                }
                return updatedSections;
            });
        }

        const payload = {
            pipeline_ids: deleteOption
        };
        const Url = `${deleteSubmission}${applicantData.form_id}`;
        axios.post(Url, payload, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Successfully Deleted', detail: '', life: 3000 });
                    setStageNames((prev) => {
                        const updated = { ...prev };
                        deleteOption.forEach(id => { updated[id] = ""; });
                        return updated;
                    });
                    if (!isFromSearch && deleteOption.includes(pipelineId)) {
                        setTotal(prev => prev - 1)
                    }
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            })
            .finally(() => {
                setVisible(false); // Close dialog
            });
    };

    const rejectDelete = () => {
        setVisible(false); // Close dialog
    };

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            Add CC Emails
        </div>
    );

    const resetEmailPopup = () => {
        setEmailPopupVisible(false);
        setWantEmail(null);
        setEmails([]);
        setEmailInput('');
    };

    const footerContent = (
        <div>
            {wantEmail === null ? (
                <>
                    <Button label="No" style={{ background: "red" }} onClick={() => {
                        resetEmailPopup();
                        setStageNames((prev) => ({ ...prev, [selectedPipelineId]: selectedStageName }));
                        handleStageUpdate(applicantData.ghl_contact_id, applicantData.form_id, selectedStageName, applicantData.app_status, [], true, selectedStageId);
                    }} autoFocus />
                    <Button label="Yes" icon="pi pi-check" onClick={() => setWantEmail(true)} autoFocus />
                </>
            ) : (
                <>
                    <Button label="Cancel" style={{ background: "red" }} onClick={resetEmailPopup} autoFocus />
                    <Button label="Continue" icon="pi pi-check" onClick={() => {
                        const pending = emailInput.trim();
                        const finalEmails = pending && !emails.includes(pending) ? [...emails, pending] : emails;
                        resetEmailPopup();
                        setStageNames((prev) => ({ ...prev, [selectedPipelineId]: selectedStageName }));
                        handleStageUpdate(applicantData.ghl_contact_id, applicantData.form_id, selectedStageName, applicantData.app_status, finalEmails, true, selectedStageId);
                    }} autoFocus />
                </>
            )}
        </div>
    );

    const convertDateToString = (date) => {
        if (!date) return '';
        const year = date?.getFullYear();
        const month = String(date.getMonth() + 1)?.padStart(2, '0'); // month is 0-based in Date
        const day = String(date.getDate())?.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const updateCustomField = () => {

        const data = {
            form_id: customFieldUpdateAppId,
            custom_field_id: 38,
            value: convertDateToString(closingDate)
        }
        console.log(data)
        axios.post(upserCustomFieldValue, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    // toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                }
            })
            .catch((error) => {
                // toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                // setLoading(false)
            })
    }

    const closingDateHeaderElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            Add Closing Date
        </div>
    );

    const closingDateFooterContent = (
        <div>
            <Button label="Cancel" style={{ background: "red" }} onClick={() => {
                setClosingDateVisible(false)
                // setIsMounted(!isMounted)
                // handleStageUpdate(app.ghl_contact_id, app.form_id, overContainer, app.app_status)
            }} autoFocus />
            <Button label="Continue" icon="pi pi-check" onClick={() => {
                setClosingDateVisible(false)
                setStageNames((prev) => ({
                    ...prev,
                    [selectedPipelineId]: selectedStageName
                }));
                let emails = []
                handleStageUpdate(applicantData.ghl_contact_id, applicantData.form_id, selectedStageName, applicantData.app_status, emails, true, selectedStageId)
                updateCustomField()
            }} autoFocus />
        </div>
    );

    return (
        <div>
            {headerSlot
                ? createPortal(<WorkingOnBanner app={applicantData} toast={toast} inHeader />, headerSlot)
                : <WorkingOnBanner app={applicantData} toast={toast} />}
            <AppModal visible={emailPopupVisible} onHide={resetEmailPopup} panelStyle={{ width: '50rem', maxWidth: '95vw' }} zIndex={1300}>
                {headerElement}
                {wantEmail === null ? (
                    <div style={{ textAlign: 'center', padding: '1rem 0' }}>
                        <p style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Do you want to send an email?</p>
                        <p style={{ fontSize: '0.85rem', color: '#888', margin: 0 }}>Select Yes to add CC email addresses, or No to continue without sending.</p>
                    </div>
                ) : (
                    <div className="p-fluid">
                        <div style={{ marginBottom: '0.5rem' }}>Emails</div>
                        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem' }}>
                            <input
                                type="email"
                                className="p-inputtext p-component"
                                style={{ flex: 1 }}
                                value={emailInput}
                                placeholder="Enter email address"
                                onChange={(e) => setEmailInput(e.target.value)}
                                onBlur={() => {
                                    const val = emailInput.trim();
                                    if (val && !emails.includes(val)) {
                                        setEmails((prev) => [...prev, val]);
                                        setEmailInput('');
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        const val = emailInput.trim();
                                        if (val && !emails.includes(val)) {
                                            setEmails((prev) => [...prev, val]);
                                            setEmailInput('');
                                        }
                                    }
                                }}
                            />
                            <Button
                                type="button"
                                label="Add"
                                icon="pi pi-plus"
                                onClick={() => {
                                    const val = emailInput.trim();
                                    if (val && !emails.includes(val)) {
                                        setEmails((prev) => [...prev, val]);
                                        setEmailInput('');
                                    }
                                }}
                                style={{ width: "auto" }}
                            />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                            {emails.map((email, i) => (
                                <span key={i} style={{ display: 'inline-flex', alignItems: 'center', background: 'black', color: 'white', borderRadius: '1rem', padding: '0.25rem 0.75rem', fontSize: '0.875rem', gap: '0.4rem' }}>
                                    {email}
                                    <i className="pi pi-times" style={{ cursor: 'pointer', fontSize: '0.75rem' }} onClick={() => setEmails((prev) => prev.filter((_, idx) => idx !== i))} />
                                </span>
                            ))}
                        </div>
                    </div>
                )}
                {footerContent}
            </AppModal>
            <AppModal visible={closingDateVisible} onHide={() => setClosingDateVisible(false)} panelStyle={{ width: '30rem', maxWidth: '95vw' }} zIndex={1300}>
                {closingDateHeaderElement}
                <div>Closing Date</div>
                <Calendar
                    style={{
                        width: '100%',
                    }}
                    value={closingDate}
                    onChange={(e) => {
                        setClosingDate(e.value)
                    }} />
                {closingDateFooterContent}
            </AppModal>
            <FlexComponent justifyContent="end" alignItems="start" gap="3rem" className="applicantContainer">
                <FlexComponent className="applicantContainer" style={{ width: '70%' }} flexDirection="column" gap="1.5rem">
                    <FlexComponent className="applicantContainer" gap="1rem">
                        <div className="applicantDivs" style={{ width: '40%' }}>
                            <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Name</div>
                            <div>{applicantData?.full_name}</div>
                        </div>
                        <div className="applicantDivs" style={{ width: '60%' }}>
                            <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Location</div>
                            <div>{applicantData?.location_name}</div>
                        </div>
                    </FlexComponent>
                    <FlexComponent gap="1rem" className="applicantContainer">
                        <div className="applicantDivs" style={{ width: '40%' }}>
                            <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Phone</div>
                            <div>{applicantData?.phone}</div>
                        </div>
                        <div className="applicantDivs" style={{ width: '60%' }}>
                            <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Email</div>
                            <div>{applicantData?.email}</div>
                        </div>
                    </FlexComponent>
                    <FlexComponent gap="1rem" className="applicantContainer">
                        <div className="applicantDivs" style={{ width: '40%' }}>
                            <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Members</div>
                            <div style={{ marginTop: '0.5rem' }}>
                                <FlexComponent gap="0.1rem" justifyContent="start" alignItems="start">
                                    <Members members={applicantData.images} contactOwners={applicantData.user_owners} locationUsers={applicantData.location_available_users} setBoardSections={setBoardSections} isFromTable={isFromTable} contactId={applicantData.ghl_contact_id} formId={applicantData?.form_id} userId={userId} toast={toast} />
                                </FlexComponent>
                            </div>
                        </div>
                        {(applicantData?.income !== "$0" || parseInt(applicantData?.credit) || applicantData?.savings !== "$0") && <FlexComponent justifyContent='start' gap='1rem' style={{ width: '60%' }}>
                            <div>
                                <p style={{ textAlign: "center", color: applicantData?.income === "$0" ? "grey" : changeIncomeColor(applicantData?.income), fontSize: '24px' }}>{applicantData?.income === "$0" ? "N/A" : applicantData?.income}</p>
                                <p>Income</p>
                            </div>
                            <div>
                                <p style={{ textAlign: "center", color: parseInt(applicantData?.credit) ? changeCreditColor(applicantData?.credit) : "grey", fontSize: applicantData?.credit.length > 5 ? '12px' : '24px' }}>{parseInt(applicantData?.credit) || "N/A"}</p>
                                <p>Credit</p>
                            </div>
                            <div>
                                <p style={{ textAlign: "center", color: applicantData?.savings === "$0" ? "grey" : changeAvailableColor(applicantData?.savings), fontSize: '24px' }}>{applicantData?.savings === "$0" ? "N/A" : applicantData?.savings}</p>
                                <p>Available</p>
                            </div>
                        </FlexComponent>}
                    </FlexComponent>
                    <FlexComponent className="applicantContainer" gap="1rem">
                        <div className="applicantDivs" style={{ width: '40%' }}>
                            <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Application By</div>
                            <div>{applicantData?.app_application_by}</div>
                        </div>
                        <div className="applicantDivs" style={{ width: '60%' }}>
                            <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Date and Time</div>
                            <div>{formatDateTime(applicantData?.created_date)}</div>
                        </div>
                    </FlexComponent>
                    <CoBorrowers coBorrowers={applicantData?.co_borrowers} locationId={applicantData?.location_id} />
                    <FlexComponent flexDirection="column" >
                        {isSuperuser && <FlexComponent gap="1rem" justifyContent="start">
                            <ConfirmPopup />
                            <Button onClick={(e) => {
                                e.stopPropagation()
                                handleArchiveCard(e)
                            }}>Archive</Button>
                            {pipelineId !== 16 &&
                                <div>
                                    <Button onClick={(e) => {
                                        e.stopPropagation()
                                        // handleInactiveCard(e)
                                        dotsOp.current.toggle(e)
                                    }}>On Hold</Button>
                                    <OverlayPanel onClick={(e) => {
                                        e.stopPropagation()
                                    }} ref={dotsOp} style={{ background: '#1A2B53' }} >
                                        <FlexComponent gap="1rem" >
                                            <div style={{ minWidth: "260px" }} onClick={(e) => {
                                                e.stopPropagation()
                                            }}>
                                                <FlexComponent style={{ marginRight: "1rem", marginTop: "1rem" }} flexDirection="column" alignItems="start" >
                                                    {/* <h3>Are you sure you want to Delete this card?</h3> */}
                                                    <div style={{color: "white"}} >Please select the On Hold Stage </div>
                                                    <div style={{ width: "100%" }} >
                                                        {allPipelinesData?.map((pipeline) => (
                                                            <div className="applicantDivs" style={{ display: pipeline.name === "Inactive Apps" && "none", width: "100%", marginTop: '.5rem' }} key={pipeline.id}>
                                                                {pipeline.name === "On Hold" && <FlexComponent flexDirection="column" alignItems="start" justifyContent="start" >
                                                                    {/* <div>{pipeline.name}</div> */}
                                                                    <Dropdown
                                                                        id={`pipeline-${pipeline.id}`}
                                                                        optionValue="name"
                                                                        optionLabel="name"
                                                                        value={stageNames[pipeline.id] || ''}
                                                                        options={pipeline.stages || []}
                                                                        style={{ width: '100%', marginTop: ".5rem" }}
                                                                        onChange={(e) => {
                                                                            const stageName = e.value;
                                                                            const stageId = pipeline.stages.find((stage) => stage.name === stageName)?.id;
                                                                            const prevStage = stagesInfo.find(
                                                                                (stage) => pipeline.id === stage.stage_pipeline_id
                                                                            )?.stage_name || null;
                                                                            const prevStageId = stagesInfo.find(
                                                                                (stage) => pipeline.id === stage.stage_pipeline_id
                                                                            )?.stage_id || null;
                                                                            const contactId = applicantData.ghl_contact_id;
                                                                            const formId = applicantData.form_id;
                                                                            const emails = [];

                                                                            setStageNames((prev) => ({
                                                                                ...prev,
                                                                                [pipeline.id]: stageName
                                                                            }));
                                                                            handleStageUpdate(contactId, formId, stageName, prevStage, emails, true, stageId, pipeline.id);

                                                                        }}
                                                                        placeholder={`Select Stage for ${pipeline.name}`}
                                                                    />
                                                                </FlexComponent>}
                                                            </div>
                                                        ))}
                                                    </div>

                                                </FlexComponent>
                                            </div>
                                        </FlexComponent>
                                    </OverlayPanel>
                                </div>
                            }
                            <Button onClick={(e) => {
                                e.stopPropagation()
                                handleDeleteCard(e)
                            }}>Delete</Button>
                        </FlexComponent>}
                        <div style={{ width: "100%" }} >
                            <Queue toast={toast} watchers={applicantData?.watchers} formId={applicantData?.form_id} userId={userId} usersList={usersList} queueUsersList={applicantData?.queue_user_list} isFromQueuePage={isFromQueuePage} fetchQueue={fetchQueue} />
                        </div>
                    </FlexComponent>

                </FlexComponent>
                <FlexComponent className="applicantContainer" style={{ width: '35%' }} flexDirection="column" gap="1rem" alignItems="start">
                    <div className="applicantDivs" style={{ width: '60%' }}>
                        <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Language</div>
                        <div>{applicantData?.language}</div>
                    </div>
                    <p>Status</p>
                    <Button onClick={() => setDocsVisible(true)} style={{ fontSize: '14px', fontWeight: "bold", background: 'transparent', border: '1px solid grey', width: '180px' }}><i className="pi pi-folder-open"></i> <span style={{ marginLeft: '0.5rem' }}>View Documents</span></Button>
                    {(isSuperuser || designation === "Loan Officer Assistant" || userId === 16) && <Button onClick={() => { DownloadLoanXMLButton() }} style={{ fontSize: '14px', fontWeight: "bold", background: 'transparent', border: '1px solid grey', width: '180px' }}><i className="pi pi-download"></i> <span style={{ marginLeft: '0.5rem' }}>Download XML</span></Button>}
                    <Button onMouseDown={() => window.open(`/app/${applicantData?.ghl_contact_id}/${applicantData?.form_id}`, '_blank')} style={{ fontSize: '14px', background: 'white', color: "black", fontWeight: "bold", border: 'none', width: '180px' }}><i className="pi pi-book"></i> <span style={{ marginLeft: '0.5rem' }}></span> View Application</Button>
                    <Button onClick={() => window.open(`https://phone.bcrumbs.com/v2/location/${applicantData?.location_id}/contacts/detail/${applicantData?.ghl_contact_id}`, '_blank')} style={{ fontSize: '14px', fontWeight: "bold", background: 'transparent', border: '1px solid grey', width: '180px' }}><i className="pi pi-external-link"></i> <span style={{ marginLeft: '0.5rem' }}>View Contact</span></Button>
                    <Button onClick={() => toggleAutoDoc()} style={{ fontSize: '14px', fontWeight: "bold", background: 'transparent', border: '1px solid grey', width: '180px', fontSize: "12px" }}><i className={autoDocToogle ? "pi pi-check-square" : "pi pi-file"}></i> <span style={{ marginLeft: '0.5rem' }}>Auto Doc Followup</span></Button>
                    <div className="applicantDivs">
                        <FlexComponent justifyContent="start" gap="1rem" style={{ marginBottom: ".5rem" }}>
                            <div style={{ fontSize: '14px', color: '#B1B1B1' }}>Due Date</div>
                            <i style={{ cursor: "pointer" }} onClick={() => setIsEditDueDate(true)} className='pi pi-pencil'></i>
                            {savedDateTime && !isEditDueDate && <i style={{ cursor: "pointer" }} onClick={() => handleUpdateDueDate(true)} className='pi pi-times'></i>}
                        </FlexComponent>
                        {isEditDueDate ? (
                            <FlexComponent gap=".5rem" alignItems="center">
                                <div style={{ width: '100px', overflow: "hidden", borderRadius: "5px" }}>
                                    <DatePicker
                                        selected={dueDateTime}
                                        onChange={(date) => {
                                            if (date && !dueDateTime) {
                                                date.setHours(7, 0, 0, 0);
                                            }
                                            setDueDateTime(date);
                                        }}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="MM/DD/YYYY"
                                        className="p-inputtext"
                                    // style={{ width: '100px' }}
                                    />
                                </div>
                                <div style={{ width: '90px', overflow: "hidden", borderRadius: "5px" }}>
                                    <DatePicker
                                        selected={dueDateTime}
                                        onChange={(date) => setDueDateTime(date)}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="Time"
                                        dateFormat="h:mm aa"
                                        placeholderText="HH:MM AA"
                                        className="p-inputtext"
                                        popperClassName="time-picker-filtered"
                                        filterTime={(time) => { const mins = time.getHours() * 60 + time.getMinutes(); return mins >= 420 && mins <= 1260; }}
                                    // style={{ width: '80px' }}
                                    />
                                </div>
                                <div>
                                    <i
                                        className="pi pi-save"
                                        style={{ cursor: 'pointer', fontSize: '1rem' }}
                                        onClick={() => handleUpdateDueDate()}
                                    ></i>
                                </div>
                                <div>
                                    <i
                                        className="pi pi-times"
                                        style={{ cursor: 'pointer', fontSize: '1rem' }}
                                        onClick={() => {
                                            setIsEditDueDate(false)
                                            setDueDateTime(applicantData?.due_date ? new Date(applicantData.due_date) : null)
                                        }}
                                    ></i>
                                </div>
                            </FlexComponent>
                        ) : (
                            <FlexComponent gap=".5rem">
                                <p>{convertDate(savedDateTime)}</p>
                            </FlexComponent>
                        )}
                    </div>
                </FlexComponent>
            </FlexComponent>
            <FlexComponent className="applicantContainer" gap="1rem">
                <div className="applicantDivs" style={{ width: '100%', marginTop: "1rem" }}>
                    <FlexComponent className="applicantContainer pipelineStageDropdown" alignItems="start" gap="1rem" flexWrap="wrap" justifyContent="start">
                        {allPipelinesData?.map((pipeline) => (
                            <div className="applicantDivs" style={{ display: pipeline.id === 16 && "none", width: "31%", marginTop: '.5rem' }} key={pipeline.id}>
                                {pipeline.id !== 16 && <FlexComponent flexDirection="column" alignItems="start" justifyContent="start" >
                                    <div>{pipeline.name}</div>
                                    <Dropdown
                                        id={`pipeline-${pipeline.id}`}
                                        optionValue="name"
                                        optionLabel="name"
                                        value={stageNames[pipeline.id] || ''}
                                        options={pipeline.stages || []}
                                        style={{ width: '100%', marginTop: ".5rem" }}
                                        onChange={(e) => {
                                            const stageName = e.value;
                                            const stageId = pipeline.stages.find((stage) => stage.name === stageName)?.id;
                                            const prevStage = stagesInfo.find(
                                                (stage) => pipeline.id === stage.stage_pipeline_id
                                            )?.stage_name || null;
                                            const prevStageId = stagesInfo.find(
                                                (stage) => pipeline.id === stage.stage_pipeline_id
                                            )?.stage_id || null;
                                            const contactId = applicantData.ghl_contact_id;
                                            const formId = applicantData.form_id;
                                            const emails = [];
                                            setSelectedStageId(stageId)


                                            if (stageName === "🤖 Auto Doc Request") {
                                                setSelectedPipelineId(pipeline.id)
                                                setSelectedStageName(stageName)
                                                setWantEmail(null)
                                                setEmailPopupVisible(true)
                                            } else if (stageName === "Closed 💰") {
                                                setCustomFieldUpdateAppId(applicantData.form_id)
                                                setSelectedPipelineId(pipeline.id)
                                                setSelectedStageName(stageName)
                                                setClosingDateVisible(true)
                                            } else {
                                                setStageNames((prev) => ({
                                                    ...prev,
                                                    [pipeline.id]: stageName
                                                }));
                                                handleStageUpdate(contactId, formId, stageName, prevStage, emails, true, stageId, pipeline.id);
                                            }
                                        }}
                                        placeholder={`Select Stage for ${pipeline.name}`}
                                    />
                                </FlexComponent>}
                            </div>
                        ))}
                    </FlexComponent>
                    {/* <Dropdown
                            id="id"
                            optionValue="name"
                            optionLabel="name"
                            value={stageName}
                            className="applicantDivs"
                            options={pipelineStages || []}
                            style={{ width: '40%', marginTop: ".5rem" }}
                            onChange={(e) => {
                                let stage = e.value
                                setStageName(stage)
                                let prevStage = id
                                let contactId = applicantData.ghl_contact_id
                                let formId = applicantData.form_id
                                let emails = []
                                handleStageUpdate(contactId, formId, stage, prevStage, emails, true)
                            }}
                            placeholder="Select"
                        /> */}
                </div>
            </FlexComponent>

            <div style={{ marginTop: "1rem" }} >
                <div><i className="pi pi-home" style={{ marginRight: "10px" }} ></i> Home Search: <ShoppingFor isFromAppPopup={true} data={applicantData} setApplicantData={setApplicantData} toast={toast} formId={applicantData?.form_id} userId={userId} /></div>
                <div style={{ marginTop: ".5rem", marginLeft: "2rem" }} >
                    <span>Shopping for {applicantData?.home_type?.join(", ")} {applicantData?.bedrooms} bed {applicantData?.bathrooms} bath in the following areas: {applicantData?.specific_area_interested_in?.map((area, index) => <span className="area-button" key={index}>{[area?.street_address, area?.city, area?.state].filter(Boolean).join(', ')}</span>)}</span>
                </div>
            </div>

            <div style={{ marginTop: "1rem" }} >
                <div><i className="pi pi-dollar" style={{ marginRight: "10px" }} ></i> Other Loans: </div>
                <div style={{ marginTop: ".5rem", marginLeft: "2rem" }} >
                    <div>{applicantData?.other_loans?.map((item, index) => <span key={index} >
                        <div>{index + 1}. Loan Id: {item.loan_id || "N/A"}</div>
                        <div style={{ marginLeft: "1rem" }} >Submitted At: {item?.submitted_at}
                            <div style={{ marginLeft: ".5rem", cursor: "pointer", background: "white" }} className="area-button" onClick={() => { window.open(`/app/${item?.contact_id}/${item?.form_id}`, '_blank') }} >View App</div>
                        </div>
                    </span>)}</div>
                </div>
            </div>
            <div style={{ marginTop: '2rem' }}>
                <FlexComponent className="applicantContainer">
                    <Label labels={applicantData.labels} setBoardSections={setBoardSections} isFromTable={isFromTable} formId={applicantData?.form_id} userId={userId} toast={toast} />
                    <Watcher toast={toast} watchers={applicantData?.watchers} formId={applicantData?.form_id} userId={userId} />
                </FlexComponent>
                <Divider />
                {designation !== "Real Estate Professional" && <>
                    <Description description={applicantData?.description} usersList={usersList} formId={applicantData?.form_id} toast={toast} />
                    <Divider />
                    <CustomField sectionName="Real Estate Transaction Details" toast={toast} applicantData={applicantData} fullName={applicantData?.full_name} setBoardSections={setBoardSections} isFromTable={isFromTable} formId={applicantData?.form_id} pipelineId={pipelineId} imagesList={applicantData?.images} customFields={applicantData?.customFields} getAllCustomFields={getAllCustomFields} allCustomFields={realEstateTransactionsCustomFields} />
                    <Divider />
                    <CustomField sectionName="Loan Details" toast={toast} applicantData={applicantData} fullName={applicantData?.full_name} setBoardSections={setBoardSections} isFromTable={isFromTable} formId={applicantData?.form_id} pipelineId={pipelineId} imagesList={applicantData?.images} customFields={applicantData?.customFields} getAllCustomFields={getAllCustomFields} allCustomFields={loanDetailsCustomFields} />
                    <Divider />
                    <CustomField sectionName="Custom Fields" toast={toast} applicantData={applicantData} fullName={applicantData?.full_name} setBoardSections={setBoardSections} isFromTable={isFromTable} formId={applicantData?.form_id} pipelineId={pipelineId} imagesList={applicantData?.images} customFields={applicantData?.customFields} getAllCustomFields={getAllCustomFields} allCustomFields={allCustomFields} />
                    <Divider />
                    <CheckListContainer userId={userId} usersList={usersList} pipelineId={pipelineId} salesUsersList={applicantData?.images} formId={applicantData?.form_id} toast={toast} handleClose={handleClose} checkListsData={applicantData?.checklist_heading} refreshToken={checklistRefreshToken} />
                    <Divider />
                    <MessageTracker formId={applicantData?.form_id} />
                </>}
                {designation === "Real Estate Professional" && <CustomField sectionName="Real Estate Transaction Details" toast={toast} applicantData={applicantData} fullName={applicantData?.full_name} setBoardSections={setBoardSections} isFromTable={isFromTable} formId={applicantData?.form_id} pipelineId={pipelineId} imagesList={applicantData?.images} customFields={applicantData?.customFields} getAllCustomFields={getAllCustomFields} allCustomFields={realEstateTransactionsCustomFields} />
                }

                <Divider />
                {applicantData?.form_id && <Activity usersList={usersList} handleClose={handleClose} toast={toast} userId={userId} formId={applicantData?.form_id} comments={applicantData?.comments} contacts={applicantData?.contacts} />}
            </div>
            <ChecklistModal
                visible={checklistModalVisible}
                onHide={() => setChecklistModalVisible(false)}
                card={applicantData}
                checklistHeadings={applicantData?.checklist_heading || []}
                formId={applicantData?.form_id}
                userId={userId}
                toast={toast}
            />

            <DocsModal
                visible={docsVisible}
                onHide={() => { setDocsVisible(false); setRenamingFileId(null); }}
                card={applicantData}
                allFilesForModal={allFilesForModal}
                allItems={allItems}
                fmtFileSize={fmtFileSize}
                renamingFileId={renamingFileId}
                setRenamingFileId={setRenamingFileId}
                renameValue={renameValue}
                setRenameValue={setRenameValue}
                handleRenameFile={handleRenameFile}
                handleRefileDoc={handleRefileDoc}
                handleAssignPendingDoc={handleAssignPendingDoc}
                handleAssignIndependentToHeading={handleAssignIndependentToHeading}
                localHeadings={localHeadings}
                handleDeleteDoc={handleDeleteDoc}
                handleToggle={handleToggle}
                setPreviewFile={setPreviewFile}
                setPreviewVisible={setPreviewVisible}
                docViewMode={docViewMode}
                setDocViewMode={setDocViewMode}
                handleModalUpload={handleModalUpload}
                handleDragDropUpload={doIndependentUpload}
                modalUploading={modalUploading}
                handleRenameToSuggestion={handleRenameToSuggestion}
                hasMoreDocs={appDocsHasMore}
                loadingMoreDocs={appDocsLoading}
                onLoadMoreDocs={loadMoreAppDocs}
                docsLoaded={appDocs.length}
                docsTotal={appDocsTotal}
                apiDocs={appDocs}
                docsOrdering={appDocsOrdering}
                onDocsOrderingChange={setAppDocsOrdering}
            />

            {previewVisible && previewFile && createPortal(
                <div className="pcq-preview-backdrop" onClick={() => { setPreviewVisible(false); setPreviewFile(null); }}>
                    <div className="pcq-preview-modal" onClick={e => e.stopPropagation()}>
                        <div className="pcq-preview-hd">
                            <PreviewTitle file={previewFile} onRename={handleRenamePreviewFile} />
                            <div className="pcq-preview-hd-actions">
                                <a className="pcq-preview-dl" href={previewFile.file_url} download={previewFile.file_name} target="_blank" rel="noreferrer">⬇ Download</a>
                                <button className="pcq-preview-close" onClick={() => { setPreviewVisible(false); setPreviewFile(null); }}>✕</button>
                            </div>
                        </div>
                        <div className="pcq-preview-body">
                            <PreviewFile isSingleFile={true} setPreviewVisible={setPreviewVisible} previewFile={previewFile} />
                        </div>
                    </div>
                </div>,
                document.body
            )}

            {uploadPickerVisible && createPortal(
                <div className="pcq-upload-picker-backdrop" onClick={cancelUploadPicker}>
                    <div className="pcq-upload-picker" onClick={e => e.stopPropagation()}>
                        <div className="pcq-upload-picker-title">
                            Upload {pendingUploadFiles.length} file{pendingUploadFiles.length !== 1 ? 's' : ''} under which section?
                        </div>
                        {localHeadings.map(h => (
                            <button key={h.id} className="pcq-upload-picker-option" onClick={() => handleUploadHeadingPick(h.id)}>
                                {h.name}
                            </button>
                        ))}
                        <button className="pcq-upload-picker-cancel" onClick={cancelUploadPicker}>Cancel</button>
                    </div>
                </div>,
                document.body
            )}

            <AppModal visible={visible} onHide={rejectDelete} panelStyle={{ width: '30rem', maxWidth: '95vw' }} zIndex={1300}>
                <div style={{ fontWeight: 600, fontSize: '1.1rem', marginBottom: '1rem' }}>Are you sure you want to Delete this card?</div>
                <FlexComponent style={{ marginBottom: '1.5rem' }} flexDirection="column" alignItems="start">
                    <div>Please select the pipeline from which you want to delete this card</div>
                    <MultiSelect
                        id={`pipeline-delete-option`}
                        optionValue="id"
                        optionLabel="name"
                        value={deleteOption}
                        options={allPipelinesData?.filter(pipeline => pipeline.name !== "Inactive Apps" && stageNames[pipeline.id]) || []}
                        style={{ minWidth: "200px", marginTop: ".5rem", marginRight: "1rem" }}
                        onChange={(e) => setDeleteOption(e.value)}
                        placeholder="Select"
                        display="chip"
                    />
                </FlexComponent>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button label="Cancel" style={{ background: "red" }} onClick={rejectDelete} />
                    <Button label="Delete" icon="pi pi-check" onClick={acceptDelete} />
                </div>
            </AppModal>
        </div>
    )
}

export default AppPopup